/**
 * resetProgress.ts
 * ---------------
 * Utility to clear all progress and state from localStorage.
 * - Used to reset onboarding/tutorial state.
 */


export function resetProgress() {
  localStorage.removeItem('points');
  localStorage.removeItem('partOneDone');
  localStorage.removeItem('partTwoDone');
  localStorage.removeItem('partThreeDone');
  localStorage.removeItem('partFourDone');
  localStorage.removeItem('crashCourseCurrentStep');
  localStorage.removeItem('latestCompletedStep');
  localStorage.removeItem('step');
}